import React, {useEffect, useState} from 'react'
import SuccessModal from "../CustomModal/Success";
import FailedModal from "../CustomModal/Failed";
import Header from "../layout/header";
import BottomMenu from "../layout/bottomMenu";
import Loader from "../../Loader/Loader";
import useLatLng from "../../hooks/uselatlng/uselatlng";
import "../Dashboard/Dashboard.css";
import "../Dashboard/Sidebar.js";
import DashboardMenu from "../layout/dashboardMenu";
import FileUpload from "../FileUploads/FileUpload";
import {toast} from "react-toastify";
import { OPPORTUNITY_LIST_URL, isNewLeadX } from '../../utils/redirection.js';

const CreateOpportunities = ({
                                 dropdownData,
                                 dropdownValue = [],
                                 save,
                                 saveDetails = [],
                                 match,
                                 opportunityQuestionDetails = [],
                                 opportunityQuestion,
                                 documentUploadUrlPublic,
                                 documentUrlDataPublic,
                                 history,
                                 accountDetailsById,
                                 accountDetails=[]
                             }) => {

    let dropdownIndexValues = [];
    const [multipleDropdown, setMultipleDropdown] = useState([{}])
    const [isLoading, setIsLoading] = useState(false)
    const [inputList, setInputList] = useState([{}])
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [opportunityTypes, setOpportunityTypes] = useState([])
    const [opportunityTypeId, setOpportunityTypeId] = useState('')
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [saveInitialArrayOfMultipleDropdown, setSaveInitialArrayOfMultipleDropdown] = useState()
    const [opportunitySolutionType, setOpportunitySolutionType] = useState([])
    const [solutionTypes, setSolutionTypes] = useState([{id: '', quantity:0, unit_price:0, solution_type:''}])
    const [redirectUrl, setRedirectUrl] = useState('')
    const[installationCost, setInstallationCost] = useState('')
    const[commercialType, setCommercialType] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            // await dropdownData()
            await accountDetailsById(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (dropdownValue?.opportunity_types !== undefined) {
            setOpportunityTypes(dropdownValue?.opportunity_types)
        }
        if (dropdownValue?.opportunity_solution_type !== undefined) {
            setOpportunitySolutionType(dropdownValue?.opportunity_solution_type)
        }

    }, [dropdownValue])


    useEffect(() => {
        let oppType = 'is_apartment'
        if(Object.keys(accountDetails).length > 0 && accountDetails?.project_name !== undefined) {
                if(accountDetails?.project_name === "Corporate"){
                    oppType = 'is_corporate'
                }else if(accountDetails?.project_name !== "Society"){
                    oppType = 'is_supply'
                }
        }

        (async () => {
            await dropdownData(oppType)
        })()
    }, [accountDetails])

    useEffect(() => {
        setMultipleDropdown([{}])
        setSaveInitialArrayOfMultipleDropdown([{}])
        let index = 0
        if (opportunityQuestionDetails && opportunityQuestionDetails.length > 0) {
            opportunityQuestionDetails.map((val, i) => {
                let object = {}
                if (parseInt(val?.is_multiple_selector) === 1) {
                    if (val?.type === 'dropdown') {
                        object = {
                            ...object,
                            [val?.label_name.split(' ').join('_')]: '',
                            [val?.label_name.split(' ').join('_') + '_other']: ''
                        }
                        if (val?.input_fields_on_dropdown_select !== null) {
                            const result = val?.input_fields_on_dropdown_select.map((value, ii) => {
                                object = {...object, [value?.label.split(' ').join('_')]: ''}
                                multipleDropdown[index] = [object]
                            })
                            saveInitialArrayOfMultipleDropdown[index] = object
                        } else {
                            multipleDropdown[index] = [object]
                            saveInitialArrayOfMultipleDropdown[index] = object
                        }
                        index++;
                        setMultipleDropdown(multipleDropdown)
                        setSaveInitialArrayOfMultipleDropdown(saveInitialArrayOfMultipleDropdown)
                    }
                } else if (val?.type === 'dropdown') {
                    inputList[0][val?.label_name.split(' ').join('_')] = ''
                    inputList[0][val?.label_name.split(' ').join('_') + '_other'] = ''
                    if (val?.input_fields_on_dropdown_select !== null) {
                        const result = val?.input_fields_on_dropdown_select.map((value, ii) => {
                            inputList[0][val?.label_name.split(' ').join('_') + "_" + value?.label.split(' ').join('_')] = ''
                        })
                    }
                    setInputList(inputList)
                }

                if (val?.type !== 'dropdown') {
                    val?.is_multiple_selector === 1 ? inputList[0][val?.label_name.split(' ').join('_')] = [] : inputList[0][val?.label_name.split(' ').join('_')] = ''
                    setInputList(inputList)
                }
            })
        }
    }, [opportunityQuestionDetails])

    useEffect(() => {
        (async () => {
            if (opportunityTypeId === '') {
                return false
            }
            setIsLoading(true)
            await opportunityQuestion(opportunityTypeId)
            setIsLoading(false)
        })()
    }, [opportunityTypeId])

    const handleAddSolutionTypes = (e, dropdownIndex, index) => {
        let objects = {}
        Object.keys(saveInitialArrayOfMultipleDropdown[dropdownIndex]).forEach(function (ii, key) {
            objects = {...objects, [ii]: ''}
        });
        multipleDropdown[dropdownIndex][index + 1] = objects
        setMultipleDropdown(multipleDropdown)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 500)
        e.preventDefault()
    }

    const handleRemoveSolutionType = (e, dropdownIndex, index) => {
        multipleDropdown[dropdownIndex].splice(index, 1);
        setMultipleDropdown(multipleDropdown)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 500)
        e.preventDefault()
    }

    const handleSolutionTypeInput = (e, index, key, val, arrayIndex) => {
        let list = [...multipleDropdown]
        list[index][arrayIndex][key] = val
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 500)
        e.preventDefault()

    }

    const handeInput = (key, val) => {
        let list = [...inputList]
        list[0][key] = val;
        setInputList(list)
    }

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            if(isNewLeadX()){
                setRedirectUrl(OPPORTUNITY_LIST_URL + `account_id=${match?.params?.id}`)
            }
            if(match?.params?.lead_id !== undefined){
                setRedirectUrl('opportunity-list/'+match?.params?.id+"/"+match?.params?.lead_id)
            }else{
                setRedirectUrl('opportunity-list/'+match?.params?.id)
            }
        } else if (saveDetails?.status !== undefined && saveDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [saveDetails])


    const handleAddSolutionType = (index) => {
        setSolutionTypes([
            ...solutionTypes, {
                id: '',
                quantity: 0,
                unit_price:0,
                solution_type:''
            }
        ])
    }

    const handleRemoveSolutionTypes = (e, index) => {
        const list = [...solutionTypes]
        list.splice(index, 1);
        setSolutionTypes(list);
        e.preventDefault()
    }

    const solutionInputList = (e, index, key, val) => {
        let list = [...solutionTypes]
        list[index][key] = val
        if(e.target.selectedOptions !== undefined){
            let desc = e.target.selectedOptions[0].text;
            list[index]["solution_type"] = desc
        }
        setSolutionTypes(list)
    }

    /**
     * @param e
     * @returns {Promise<void>}
     */
    const handleSubmit = async (e) => {
        e.preventDefault()
        inputList[0]['details'] = multipleDropdown
        inputList[0]['latitude'] = islatlng?.lat
        inputList[0]['longitude'] = islatlng?.lng
        if(inputList[0]['longitude'] == null || inputList[0]['latitude'] == null){
            toast.error('Please enable your location');
            return false
        }

        inputList[0]['account_id'] = match?.params?.id
        inputList[0]['opportunity_type_id'] = opportunityTypeId
        inputList[0]['solution_types'] = solutionTypes
        inputList[0]['installation_cost'] = installationCost
        inputList[0]['commercial_type'] = commercialType
        // for v2
        inputList[0]['not_new_activity'] = true
        inputList[0]['is_check_closure'] = true
        if(match?.params?.lead_id !== undefined){
            inputList[0]['lead_id'] = match?.params?.lead_id
        }

        setIsLoading(true)
        await save(inputList[0])
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={saveDetails?.message}
                url={redirectUrl}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={saveDetails?.message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Add Opportunity"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid">
                            {/*Heading*/}
                            {/* <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-black-100">Add Opportunities</h1>
                            </div> */}
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            {/* <div className="card-header bg-lightGreen-active">
                                                Opportunities
                                            </div> */}
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-sm-6 float-field uu-select">
                                                            <select className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        setOpportunityTypeId(e.target.value)
                                                                    }} required>
                                                                <option value="">Select Opportunity Type</option>
                                                                {opportunityTypes && opportunityTypes.map((val) => {
                                                                    return (
                                                                        <option
                                                                            value={val?.id}>{val.name}</option>
                                                                    )
                                                                })}

                                                            </select>
                                                            <label className="large-label float-lb">
                                                                Opportunity Type
                                                            </label>
                                                        </div>
                                                        {/*{parseInt(opportunityTypeId) === 1 &&*/}
                                                        {/*    <>*/}
                                                        {/*        <div className="col-sm-6 float-field uu-select ">*/}
                                                        {/*            <select*/}
                                                        {/*                className="form-control form-control-user"*/}
                                                        {/*                onChange={(e) => {*/}
                                                        {/*                    setCommercialType(e.target.value)*/}
                                                        {/*                }}*/}
                                                        {/*                required={true}*/}
                                                        {/*            >*/}
                                                        {/*                <option value="">Select</option>*/}
                                                        {/*                <option value="capex">Capex</option>*/}
                                                        {/*                <option value="rental">Rental</option>*/}
                                                        {/*            </select>*/}
                                                        {/*            <label*/}
                                                        {/*                className="large-label float-lb">*/}
                                                        {/*                Commercial Type*/}
                                                        {/*            </label>*/}
                                                        {/*        </div>*/}
                                                        {/*        <div*/}
                                                        {/*            className="col-sm-6 float-field uu-input d-mtk-2">*/}
                                                        {/*            <input*/}
                                                        {/*                type="number"*/}
                                                        {/*                className="form-control form-control-user"*/}
                                                        {/*                // placeholder={val?.placeholder}*/}
                                                        {/*                placeholder=" "*/}
                                                        {/*                onChange={(e) => {*/}
                                                        {/*                    setInstallationCost(e.target.value)*/}
                                                        {/*                }}*/}
                                                        {/*                required*/}
                                                        {/*            />*/}
                                                        {/*            <label*/}
                                                        {/*                className="large-label float-lb">*/}
                                                        {/*                Installation Cost*/}
                                                        {/*            </label>*/}
                                                        {/*        </div>*/}
                                                        {/*        {solutionTypes.map((val, i) => {*/}
                                                        {/*            return (*/}
                                                        {/*                <>*/}
                                                        {/*                    <div*/}
                                                        {/*                        className="col-sm-6 float-field uu-select d-mtk-2"*/}
                                                        {/*                        id={Math.floor(Math.random() * 100)}>*/}
                                                        {/*                        <select*/}
                                                        {/*                            className="form-control form-control-user"*/}
                                                        {/*                            onChange={(e) => {*/}
                                                        {/*                                solutionInputList(e, i, 'id' ,e.target.value)*/}
                                                        {/*                            }}*/}
                                                        {/*                            required={val?.is_required}*/}
                                                        {/*                        >*/}
                                                        {/*                            <option value="">Select</option>*/}
                                                        {/*                            {opportunitySolutionType.map((value, index) => {*/}
                                                        {/*                                return (*/}
                                                        {/*                                    <option value={value?.id}>{value?.name}</option>*/}
                                                        {/*                                )*/}
                                                        {/*                            })}*/}
                                                        {/*                        </select>*/}
                                                        {/*                        <label*/}
                                                        {/*                            className="large-label float-lb">*/}
                                                        {/*                            Solution Type*/}
                                                        {/*                        </label>*/}
                                                        {/*                    </div>*/}
                                                        {/*                    <div*/}
                                                        {/*                        className="col-sm-6 float-field uu-input">*/}
                                                        {/*                        <input*/}
                                                        {/*                            type="text"*/}
                                                        {/*                            className="form-control form-control-user"*/}
                                                        {/*                            placeholder=" "*/}
                                                        {/*                            onChange={(e) => {*/}
                                                        {/*                                solutionInputList(e, i , 'quantity' ,e.target.value)*/}
                                                        {/*                            }}*/}
                                                        {/*                            required*/}
                                                        {/*                        />*/}
                                                        {/*                        <label*/}
                                                        {/*                            className="large-label float-lb">*/}
                                                        {/*                            Quantity*/}
                                                        {/*                        </label>*/}
                                                        {/*                    </div>*/}
                                                        {/*                    <div*/}
                                                        {/*                        className="col-sm-6 float-field uu-input">*/}
                                                        {/*                        <input*/}
                                                        {/*                            type="text"*/}
                                                        {/*                            className="form-control form-control-user"*/}
                                                        {/*                            placeholder=" "*/}
                                                        {/*                            onChange={(e) => {*/}
                                                        {/*                                solutionInputList(e, i , 'unit_price' ,e.target.value)*/}
                                                        {/*                            }}*/}
                                                        {/*                            required*/}
                                                        {/*                        />*/}
                                                        {/*                        <label*/}
                                                        {/*                            className="large-label float-lb">*/}
                                                        {/*                            Unit Price*/}
                                                        {/*                        </label>*/}
                                                        {/*                    </div>*/}
                                                        {/*                    <div className="btn-box mb-4">*/}
                                                        {/*                        {solutionTypes.length !== 1 &&*/}
                                                        {/*                            <>*/}
                                                        {/*                                <button*/}
                                                        {/*                                    onClick={(e) => handleRemoveSolutionTypes(e, i)}*/}
                                                        {/*                                    className="btn btn-sm btn-danger ml-3 btn-ar">Remove*/}
                                                        {/*                                </button>*/}
                                                        {/*                            </>*/}
                                                        {/*                        }*/}
                                                        {/*                        {solutionTypes.length - 1 === i &&*/}
                                                        {/*                            <button type="button"*/}
                                                        {/*                                    className="btn btn-sm btn-primary ml-3 btn-ar"*/}
                                                        {/*                                    onClick={() => handleAddSolutionType()}>Add More*/}
                                                        {/*                            </button>}*/}
                                                        {/*                    </div>*/}
                                                        {/*                </>*/}
                                                        {/*            )*/}
                                                        {/*        })}*/}
                                                        {/*    </>*/}
                                                        {/*}*/}
                                                        {opportunityQuestionDetails && opportunityQuestionDetails.length > 0 &&
                                                            opportunityQuestionDetails.map((val, i) => {
                                                                return (
                                                                    <>
                                                                        {val?.type === 'dropdown' &&
                                                                            <>
                                                                                {parseInt(val?.is_multiple_selector) === 1 ?
                                                                                    <>
                                                                                        {i === 0 && Object.keys(multipleDropdown).length > 0 && multipleDropdown &&
                                                                                            multipleDropdown.map((dropdowns, dropdownIndex) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        {dropdowns && dropdowns.length !== undefined && dropdowns[0] !== undefined && Object.keys(dropdowns[0]).length > 0 && dropdowns.map((v, index) => {
                                                                                                            return (
                                                                                                                <>
                                                                                                                    <div
                                                                                                                        className="col-sm-12 float-field uu-select d-mtb-3"
                                                                                                                        id={Math.floor(Math.random() * 100)}>
                                                                                                                        <div
                                                                                                                            hidden={true}>
                                                                                                                            {dropdownIndexValues = opportunityQuestionDetails.findIndex(p => p.label_name == Object.keys(v)[0].replaceAll('_', " "))}
                                                                                                                        </div>
                                                                                                                        <select
                                                                                                                            className="form-control form-control-user"
                                                                                                                            onChange={(e) => {
                                                                                                                                handleSolutionTypeInput(e, dropdownIndex, val?.label_name.split(' ').join('_'), e.target.value, index)
                                                                                                                            }}
                                                                                                                            required={val?.is_required}
                                                                                                                        >
                                                                                                                            <option
                                                                                                                                value="">Select
                                                                                                                            </option>

                                                                                                                            {opportunityQuestionDetails[dropdownIndexValues]?.values.map((value) => {
                                                                                                                                return (
                                                                                                                                    <option
                                                                                                                                        value={value}>{value}
                                                                                                                                    </option>
                                                                                                                                )
                                                                                                                            })}
                                                                                                                        </select>
                                                                                                                        <label
                                                                                                                            className="large-label float-lb">
                                                                                                                            {Object.keys(v)[0].replaceAll('_', " ")}
                                                                                                                        </label>
                                                                                                                    </div>
                                                                                                                    {(multipleDropdown[dropdownIndex][index][val?.label_name.split(' ').join('_')] === 'Others' ||
                                                                                                                            multipleDropdown[dropdownIndex][index][val?.label_name.split(' ').join('_')] === 'Other') &&
                                                                                                                        parseInt(val?.is_input_required_on_other) === 1 &&
                                                                                                                        <div
                                                                                                                            className="col-sm-6 float-field uu-input">
                                                                                                                            <input
                                                                                                                                type="text"
                                                                                                                                className="form-control form-control-user"
                                                                                                                                placeholder=" "
                                                                                                                                onChange={(e) => {
                                                                                                                                    handleSolutionTypeInput(e, dropdownIndex, val?.label_name.split(' ').join('_') + '_other', e.target.value, index)
                                                                                                                                }}
                                                                                                                                required
                                                                                                                            />
                                                                                                                            <label
                                                                                                                                className="large-label float-lb">
                                                                                                                                {val?.label_name} Others
                                                                                                                            </label>
                                                                                                                        </div>
                                                                                                                    }
                                                                                                                    {val?.input_fields_on_dropdown_select !== null &&
                                                                                                                        val?.input_fields_on_dropdown_select.map((value, value1) => {
                                                                                                                            return (
                                                                                                                                <>
                                                                                                                                    <div
                                                                                                                                        className="col-sm-6 float-field uu-input"
                                                                                                                                        id={Math.floor(Math.random() * 100)}>
                                                                                                                                        <input
                                                                                                                                            type={value?.type}
                                                                                                                                            className="form-control form-control-user"
                                                                                                                                            // placeholder={value?.placeholder}
                                                                                                                                            placeholder=" "
                                                                                                                                            onChange={(e) => {
                                                                                                                                                handleSolutionTypeInput(e, dropdownIndex, value?.label.split(' ').join('_'), e.target.value, index)
                                                                                                                                            }}
                                                                                                                                            required={value?.is_required}
                                                                                                                                        />
                                                                                                                                        <label
                                                                                                                                            className="large-label float-lb">
                                                                                                                                            {value?.label}
                                                                                                                                        </label>
                                                                                                                                    </div>
                                                                                                                                </>
                                                                                                                            )
                                                                                                                        })
                                                                                                                    }
                                                                                                                    <div
                                                                                                                        className="btn-box mb-4"
                                                                                                                        style={{"width": "100%"}}>
                                                                                                                        {multipleDropdown[dropdownIndex].length !== 1 &&
                                                                                                                            <button
                                                                                                                                onClick={(e) => handleRemoveSolutionType(e, dropdownIndex, index)}
                                                                                                                                className="btn btn-sm btn-danger ml-3">Remove
                                                                                                                            </button>
                                                                                                                        }
                                                                                                                        {multipleDropdown[dropdownIndex].length - 1 === index &&
                                                                                                                            <button
                                                                                                                                className="btn btn-sm btn-primary ml-3"
                                                                                                                                onClick={(e) => handleAddSolutionTypes(e, dropdownIndex, index)}>Add
                                                                                                                            </button>
                                                                                                                        }
                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )
                                                                                                        })}
                                                                                                    </>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </> :
                                                                                    <>
                                                                                        <div
                                                                                            className="col-sm-6 float-field uu-select">
                                                                                            <select
                                                                                                className="form-control form-control-user"
                                                                                                onChange={(e) => {
                                                                                                    handeInput(val?.label_name.split(' ').join('_'), e.target.value)
                                                                                                }}
                                                                                                required={val?.is_required}
                                                                                            >
                                                                                                <option
                                                                                                    value="">Select
                                                                                                </option>
                                                                                                {val?.values.map((value) => {
                                                                                                    return (
                                                                                                        <option
                                                                                                            value={value}>{value}</option>
                                                                                                    )
                                                                                                })}
                                                                                            </select>
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                {val?.label_name}
                                                                                            </label>
                                                                                        </div>
                                                                                        {(inputList[0][val?.label_name.split(' ').join('_')] === 'Others' ||
                                                                                                inputList[0][val?.label_name.split(' ').join('_')] === 'Other') &&
                                                                                            parseInt(val?.is_input_required_on_other) === 1 &&
                                                                                            <div
                                                                                                className="col-sm-6 float-field uu-input">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control form-control-user"
                                                                                                    // placeholder={value?.placeholder}
                                                                                                    placeholder=" "
                                                                                                    onChange={(e) => {
                                                                                                        handeInput(val?.label_name.split(' ').join('_') + '_other', e.target.value)
                                                                                                    }}
                                                                                                    required
                                                                                                />
                                                                                                <label
                                                                                                    className="large-label float-lb">
                                                                                                    {val?.label_name} Others
                                                                                                </label>
                                                                                            </div>
                                                                                        }
                                                                                        {val?.input_fields_on_dropdown_select !== null &&
                                                                                            val?.input_fields_on_dropdown_select.map((value, value1) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        <div
                                                                                                            className="col-sm-6 float-field uu-input">

                                                                                                            <input
                                                                                                                type={value?.type}
                                                                                                                className="form-control form-control-user"
                                                                                                                // placeholder={value?.placeholder}
                                                                                                                placeholder=" "
                                                                                                                onChange={(e) => {
                                                                                                                    handeInput(val?.label_name.split(' ').join('_') + "_" + value?.label.split(' ').join('_'), e.target.value)
                                                                                                                }}
                                                                                                                required={value?.is_required}
                                                                                                            />
                                                                                                            <label
                                                                                                                className="large-label float-lb">
                                                                                                                {value?.label}
                                                                                                            </label>
                                                                                                        </div>
                                                                                                    </>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        }

                                                                        {val?.type === 'date' &&
                                                                            <div
                                                                                className="col-sm-6 float-field uu-input">
                                                                                <input
                                                                                    type={val?.type}
                                                                                    className="form-control form-control-user"
                                                                                    // placeholder={val?.placeholder}
                                                                                    placeholder=" "
                                                                                    onChange={(e) => {
                                                                                        handeInput(val?.label_name.split(' ').join('_'), e.target.value)
                                                                                    }}
                                                                                    required={val?.is_required}
                                                                                />
                                                                                <label
                                                                                    className="large-label float-lb">
                                                                                    {val?.label_name}
                                                                                </label>
                                                                            </div>
                                                                        }

                                                                        {val?.type === 'number_text' &&
                                                                            <div
                                                                                className="col-sm-6 float-field uu-input">
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control form-control-user"
                                                                                    // placeholder={val?.placeholder}
                                                                                    placeholder=" "
                                                                                    onChange={(e) => {
                                                                                        handeInput(val?.label_name.split(' ').join('_'), e.target.value)
                                                                                    }}
                                                                                    required={val?.is_required}
                                                                                />
                                                                                <label
                                                                                    className="large-label float-lb">
                                                                                    {val?.label_name}
                                                                                </label>
                                                                            </div>
                                                                        }

                                                                        {val?.type === 'text' &&
                                                                            <div
                                                                                className="col-sm-6 float-field uu-input">
                                                                                <input
                                                                                    type={val?.type}
                                                                                    className="form-control form-control-user"
                                                                                    // placeholder={val?.placeholder}
                                                                                    placeholder=" "
                                                                                    onChange={(e) => {
                                                                                        handeInput(val?.label_name.split(' ').join('_'), e.target.value)
                                                                                    }}
                                                                                    required={val?.is_required}
                                                                                />
                                                                                <label
                                                                                    className="large-label float-lb">
                                                                                    {val?.label_name}
                                                                                </label>
                                                                            </div>
                                                                        }

                                                                        {val?.type === 'file' &&
                                                                            <div
                                                                                className="col-sm-6 float-field uu-input">
                                                                                <FileUpload
                                                                                    id={"addAttachment"+1}
                                                                                    accept=".png,.jpg,.jpeg"
                                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                                    documentUrlData={documentUrlDataPublic}
                                                                                    onChange={(data) => {
                                                                                        handeInput(val?.label_name.split(' ').join('_'), data)
                                                                                    }}
                                                                                    prefilledFilename={""}
                                                                                    multiple={parseInt(val?.is_multiple_selector)}
                                                                                >
                                                                                    {val?.label_name}

                                                                                </FileUpload>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default CreateOpportunities